import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconShareDoc } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openFileSharingPanel } from '../../../chat/actions.any';
import { isFileSharingEnabled } from '../../functions.any';
/**
 * Component that renders a button to open the file sharing panel.
 *
 * @augments AbstractButton
 */
class FileSharingButton extends AbstractButton {
    icon = IconShareDoc;
    label = 'toolbar.fileSharing';
    tooltip = 'toolbar.fileSharing';
    /**
     * Handles clicking the button to open the file sharing panel.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(openFileSharingPanel());
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @returns {Object} - Mapped props.
 */
function mapStateToProps(state) {
    return {
        visible: isFileSharingEnabled(state)
    };
}
export default translate(connect(mapStateToProps)(FileSharingButton));
